import React from 'react';
import download from '../img/file-download-line.png'

export default class FrontDocuments extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        const {devis} = this.props.container
        const documents = devis.documents.filter( doc => !doc.name.includes('BON_COM') )
        return <>{documents.map( doc => 
            <a key={doc.name} className="document_download" href={this.props.api.downloadDocument(devis._id.$oid,doc.name)}><img src={download}/> {doc.name}</a>
        )}</>
    }
}